import React, { useEffect } from "react";
import Banner from "./components/banner/Banner";
import TechStrip from "./components/banner/TechStrip";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import Skills from "./components/skills/Skills";
import Library from "./components/library/Library";
import ScrollToTop from "./components/layouts/ScrollToTop";
import ScrollProgress from "./components/layouts/ScrollProgress";

// Feeds the cursor position to whichever .card is hovered, for the glow effect in index.css.
const useCardSpotlight = () => {
  useEffect(() => {
    const onMove = (e) => {
      const card = e.target.closest && e.target.closest(".card");
      if (!card) return;
      const rect = card.getBoundingClientRect();
      card.style.setProperty("--mx", `${e.clientX - rect.left}px`);
      card.style.setProperty("--my", `${e.clientY - rect.top}px`);
    };
    document.addEventListener("pointermove", onMove, { passive: true });
    return () => document.removeEventListener("pointermove", onMove);
  }, []);
};

function App() {
  useCardSpotlight();
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4 relative overflow-x-hidden">
      <ScrollProgress />
      {/* soft background glows */}
      <div className="pointer-events-none absolute top-[-200px] left-[-200px] w-[600px] h-[600px] rounded-full bg-designColor/10 blur-[120px]"></div>
      <div className="pointer-events-none absolute top-[40%] right-[-250px] w-[600px] h-[600px] rounded-full bg-[#ff8a5c]/5 blur-[120px]"></div>
        <Navbar />
      <main className="max-w-screen-xl mx-auto relative pt-24 lgl:pt-28 pb-20 lgl:pb-0">
        <Banner />
        <TechStrip />
        <About />
        <Projects />
        <Experience />
        <Skills />
        <Library />
        <Contact />
        <Footer />
        <FooterBottom />
      </main>
      <ScrollToTop />
    </div>
  );
}

export default App;
